module.exports = __webpack_public_path__ + "static/media/emergency-room.5a27394d.md";


//////////////////
// WEBPACK FOOTER
// ./src/md/emergency-room.md
// module id = 2887
// module chunks = 0